import React from "react";
import { InputGridWrapper, SettingsContainerWrapper } from "./settingComponents";
import TurnrDropdownSelect from "~/components/input/TurnrDropdownSelect.jsx";
import TurnrInput from "~/components/input/TurnrInput.jsx";
import { getShopFrameBorderEffectOptions } from "~/cores/appCore";

export default function WindowSettings(props) {
    const { iFrameData, appProps } = props;
    return (
        <SettingsContainerWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    tooltip="This setting is especially important if you are using the return app as an iframe. To make sure it blends well with your own background color."
                    label={"Window background color: " + props.backgroundFrameColor?.value}
                    type="color"
                    fullWidth={true}
                    {...props.backgroundFrameColor}
                    onChange={props.setBackgroundFrameColor}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    tooltip="This changes the opacity/transparency of the window in the middle when you have a background media"
                    label="Window opacity in %"
                    type="number"
                    fullWidth={true}
                    {...props.backgroundImageOpacity}
                    onChange={props.setBackgroundImageOpacity}
                    min={0}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    tooltip="This changes the blur effect of the window in the middle when you have a background media"
                    label="Window blur in px"
                    type="number"
                    fullWidth={true}
                    {...props.backgroundImageBlur}
                    onChange={props.setBackgroundImageBlur}
                    min={0}
                    step={0.1}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    label="Window padding Mobile"
                    tooltip={
                        <div>
                            Force a specific padding on Mobile view if you prefer that over the default. Value is in px
                            <br />
                            <br />
                            Does not effect Iframe
                        </div>
                    }
                    placeholder={"Default"}
                    type="number"
                    fullWidth={true}
                    {...props.framePaddingMobile}
                    onChange={props.setFramePaddingMobile}
                    min={0}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrInput
                    size={"small"}
                    label="Window padding PC"
                    tooltip={
                        <div>
                            Force a specific padding on PC view if you prefer that over the default. Value is in px
                            <br />
                            <br />
                            Does not effect Iframe
                        </div>
                    }
                    placeholder={"Default"}
                    type="number"
                    fullWidth={true}
                    {...props.framePaddingPc}
                    onChange={props.setFramePaddingPc}
                    min={0}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    label="Window border effect"
                    tooltip={
                        <div>
                            Change the effect around the border of the centered window
                            <br />
                            <br />
                            Does not effect Iframe
                        </div>
                    }
                    selectNoneComponent={"Light shadow"}
                    fullWidth={true}
                    {...props.frameBorderEffect}
                    onChange={props.setFrameBorderEffect}
                    options={getShopFrameBorderEffectOptions(appProps)}
                />
            </InputGridWrapper>
            <InputGridWrapper>
                <TurnrDropdownSelect
                    size={"small"}
                    label="Window edges"
                    tooltip="Change roundness of centered window in PC view. Does not change anything in phone view or iframe view"
                    fullWidth={true}
                    {...props.windowType}
                    onChange={props.setWindowType}
                    options={iFrameData?.windowTypeOptions || []}
                />
            </InputGridWrapper>
        </SettingsContainerWrapper>
    );
}
